import request from '../utils/request'

/**
 * SaaS 优惠合作 · 客如云渠道（老辛 2026-10-10）。
 *
 * <p>链路：外部渠道 → 门店 → 租赁单 → 免押单。
 * 运营在后台对免押单做资金操作：扣款 / 部分扣款 / 取消扣款 / 取消免押单。
 *
 * ⚠️ 四个资金操作都会动真实资金，前端必须二次确认；
 *    按钮可点性由后端返回的 canPay / canUnfreeze 决定，不在前端另算。
 */
const saasChannelService = {
  /** 免押单分页列表 */
  listCreditOrders: (data) => {
    return request({
      url: '/saasChannel/creditOrder/list',
      method: 'post',
      data
    })
  },

  /** 免押单详情（含操作流水） */
  getCreditOrderDetail: (rentalNo) => {
    return request({
      url: '/saasChannel/creditOrder/detail',
      method: 'post',
      data: { rentalNo }
    })
  },

  /** 渠道门店下拉 */
  listStores: (extSystem) => {
    return request({
      url: '/saasChannel/store/list',
      method: 'post',
      data: { extSystem }
    })
  },

  /** 全额扣款：把剩余可扣额度一次扣完 */
  payFull: (data) => {
    return request({
      url: '/saasChannel/creditOrder/payFull',
      method: 'post',
      data
    })
  },

  /** 部分扣款：扣指定金额，可多次累加 */
  payPartial: (data) => {
    return request({
      url: '/saasChannel/creditOrder/payPartial',
      method: 'post',
      data
    })
  },

  /** 取消扣款：解冻剩余资金 */
  unfreeze: (data) => {
    return request({
      url: '/saasChannel/creditOrder/unfreeze',
      method: 'post',
      data
    })
  },

  /** 取消免押单：作废该单（已扣部分不退） */
  cancelOrder: (data) => {
    return request({
      url: '/saasChannel/creditOrder/cancelOrder',
      method: 'post',
      data
    })
  },

  /**
   * 关闭交易：仅限「已发起但扣款失败、一直没扣到」的交易。
   * ⚠️ 已扣款成功的不能关，只能退款 —— 支付宝 trade.close 只关未付款交易。
   */
  closeTrade: (data) => {
    return request({
      url: '/saasChannel/opLog/closeTrade',
      method: 'post',
      data
    })
  },

  /** 退款：针对扣款成功的流水，支持部分退款（amount 留空=全额退剩余） */
  refund: (data) => {
    return request({
      url: '/saasChannel/opLog/refund',
      method: 'post',
      data
    })
  },

  /** 某笔流水当前可否关闭/退款（控按钮用） */
  checkOpLog: (opLogId) => {
    return request({
      url: '/saasChannel/opLog/check',
      method: 'post',
      data: { opLogId }
    })
  },

  /** 操作流水 */
  listOpLogs: (rentalNo, limit) => {
    return request({
      url: '/saasChannel/opLog/list',
      method: 'post',
      data: { rentalNo, limit }
    })
  }
}

export default saasChannelService
